// ─── COLOURS ────────────────────────────────────────────────

export const COLOR = {
  // Backgrounds
  cream:        '#FAF7F2',   // app background
  blush:        '#F5E6EA',   // edit panel surfaces
  blushLight:   '#FFF8F5',   // gradient starts, lightest surface
  warmSurface:  '#F5EFE6',   // warm mid-surface
  altCardGradient: '#FFF5F0', // alt plan card gradient start
  cardAltBody:  '#FFFAF8',   // alt plan card body background
  white:        '#FFFFFF',

  // Text
  inkDark:      '#2C1810',   // primary text — USE THIS everywhere (not #3D2B1F)
  inkMid:       '#8B7355',   // secondary / muted text, labels
  inkLight:     '#A89070',   // placeholder, very muted

  // Accent — mauve/rose
  mauve:        '#B07080',   // primary accent, buttons, active states
  mauveDark:    '#7A3D50',   // error states, dark accent
  mauveLight:   '#E8B4B8',   // light accent tints

  // Borders & dividers
  borderWarm:   '#E8DDD0',   // standard border — USE THIS everywhere (not #E8D5C4 or #C4A882)
  borderMid:    '#D4C9BC',   // resize handles, heavier dividers

  // Interactive
  buttonSecondary: '#F0EAE0', // secondary/cancel button background
  dragHandle:      '#C8B8A8', // drag handle icon color

  // Category badges
  categoryBadgeBg:   '#EDE8E0', // category badge background
  categoryBadgeText: '#6B5744', // category badge text

  // Semantic
  diffBorder:   '#86efac',   // green diff border (version history)
  diffBg:       '#F0FFF4',   // green diff background
  savedGreen:   '#166534',   // success/saved state
  lockedGreen:  '#4A7C59',   // locked day indicator (border + checkmark)
  overlayDark:  '#08090c',   // photo overlays

  // Booking status pill colors
  bookNowBg:      '#FFF8E7',  // booking status: book_now/day_of background
  bookNowBorder:  '#D4A843',  // booking status: book_now/day_of border & text
  bookAheadBg:    '#F0FAF4',  // booking status: booked background
  unbookedBg:     '#FFF0F5',  // booking status: book_far_ahead/book_now pink bg
  warmSurfaceAlt: '#F8F4EF',  // slightly warmer surface variant (booking pills)

  // Cost-type badge colors (CC/CC_TEXT in constants.js)
  costLow:               '#93c5fd',  // CC.low badge bg
  costLowText:           '#1d4ed8',  // CC_TEXT.low badge text
  costModerate:          '#fcd34d',  // CC.moderate badge bg
  costModerateText:      '#6B4C5E',  // CC_TEXT.moderate badge text
  costFlight:            '#c084fc',  // CC.flight badge bg
  costFlightText:        '#6d28d9',  // CC_TEXT.flight badge text
  costAccommodation:     '#fb7185',  // CC.accommodation badge bg
  costAccommodationText: '#9d174d',  // CC_TEXT.accommodation badge text

  // Category badge colors (CATEGORY_COLORS)
  catCultureBg:          '#F0F0FF',
  catCultureText:        '#5B5BA0',
  catTransportBg:        '#FFF8E8',
  catAccommodationBg:    '#F5F0FF',
  catAccommodationText:  '#7A5090',
  catShoppingBg:         '#FFF0F8',
  catShoppingText:       '#B05080',
  catNatureBg:           '#F0FFF0',
  catNatureText:         '#3A7A3A',
};

// ─── TYPOGRAPHY ─────────────────────────────────────────────

export const FONT = {
  serif:    "Georgia, 'Times New Roman', serif",
  display:  "'Cormorant Garamond', Georgia, serif",
  mono:     'monospace',
  sansSerif: 'system-ui, -apple-system, sans-serif',
};

export const TEXT = {
  // Display
  pageTitle:    { fontFamily: FONT.serif,  fontSize: 28, color: COLOR.inkDark },
  sectionTitle: { fontFamily: FONT.serif,  fontSize: 22, color: COLOR.inkDark },
  cardTitle:    { fontFamily: FONT.serif,  fontSize: 19, color: COLOR.inkDark },

  // Body
  body:         { fontFamily: FONT.serif,  fontSize: 13, color: COLOR.inkDark, lineHeight: 1.5 },
  detail:       { fontFamily: FONT.serif,  fontSize: 11, color: COLOR.inkMid,  lineHeight: 1.4 },

  // Labels (monospace caps)
  label:        { fontFamily: FONT.mono, fontSize: 10, color: COLOR.inkMid,
                  letterSpacing: '0.1em', textTransform: 'uppercase' },
  labelSmall:   { fontFamily: FONT.mono, fontSize: 9,  color: COLOR.inkMid,
                  letterSpacing: '0.08em', textTransform: 'uppercase' },
};

// ─── SPACING & SHAPE ────────────────────────────────────────

export const RADIUS = {
  sm:  4,
  md:  8,
  lg:  12,
  xl:  16,
  pill: 999,
};

export const SPACING = {
  pagePadding:  '24px',
  cardPadding:  '20px',
  sectionGap:   '32px',
  cardGap:      '12px',
  heroHeight:   '260px',   // current — will increase during branding pass
};

export const SHADOW = {
  card:    '0 1px 4px rgba(44,24,16,0.08)',
  cardHover: '0 4px 16px rgba(44,24,16,0.12)',
  panel:   '0 8px 32px rgba(44,24,16,0.12)',
};

// ─── COMING SOON BADGE (shared component pattern) ───────────

export const BADGE = {
  comingSoon: {
    fontSize: 9,
    fontFamily: FONT.mono,
    background: COLOR.blush,
    color: COLOR.mauve,
    padding: '2px 6px',
    borderRadius: RADIUS.sm,
    letterSpacing: '0.08em',
    marginLeft: 8,
  },
};
